import Axios from 'axios'; // 刷新token

export function RefreshToken() {
  var _this = this;

  return Axios.post('Account/RefreshToken', {}).then(function (res) {
    if (res.status === 200) {
      return res.data;
    } else {
      Promise.reject();
    }
  }).catch(function (err) {
    return _this.$notify.error('网络异常！');
  });
}
export function SignIn(data) {
  var _this2 = this;

  return Axios.post('Account/SignIn', data).then(function (res) {
    if (res.status === 200) {
      return res.data;
    } else {
      Promise.reject();
    }
  }).catch(function (err) {
    return _this2.$notify.error('网络异常！');
  });
}
export function GetNonce(loginid) {
  var _this3 = this;

  return Axios.get('Account/GetNonce', {
    params: {
      loginid: loginid
    }
  }).then(function (res) {
    if (res.status === 200) {
      return res.data;
    } else {
      Promise.reject();
    }
  }).catch(function (err) {
    return _this3.$notify.error('网络异常！');
  });
}